export default [
  {
    degree: 0,
    text: '崭新出厂'
  },
  {
    degree: 1,
    text: '略有磨损'
  },
  {
    degree: 2,
    text: '久经沙场'
  },
  {
    degree: 3,
    text: '破损不堪'
  },
  {
    degree: 4,
    text: '战痕累累'
  },
  {
    degree: 5,
    text: '无涂装'
  }
]
